    <template>
      <div class="card mb-25 border-0 rounded-0 bg-white add-categorie-card">
        <div class="card-header">
          <h3 class="text-black fw-semibold">Ajouter une offre</h3>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
          <Form ref="offreForm" @submit="addOffre" :validation-schema="offreSchema">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Catégorie d'offres <span class="text-danger">*</span>
                  </label>
                  <Field name="categorieOffre" v-slot="{ field }">
                    <Multiselect :options="categorieOffresOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner la catégorie" />
                  </Field>
                </div>
                <ErrorMessage name="categorieOffre" class="text-danger" />
              </div>

              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Titre <span class="text-danger">*</span>
                  </label>
                  <Field name="titre" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le titre" />
                  <ErrorMessage name="titre" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Activités <span class="text-danger">*</span>
                  </label>
                  <Field name="activite" v-slot="{ field }">
                    <Multiselect :options="activiteOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner l'activité" />
                  </Field>
                </div>
                <ErrorMessage name="activite" class="text-danger" />
              </div>
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Prétention salariale <span class="text-danger">*</span>
                  </label>
                  <Field name="salaire" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le salaire" />
                  <ErrorMessage name="salaire" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Commune <span class="text-danger">*</span>
                  </label>
                  <Field name="commune" v-slot="{ field }">
                    <Multiselect :options="communeOptions" :searchable="true" track-by="label" label="label"
                      v-model="field.value" v-bind="field" placeholder="Sélectionner la commune" />
                  </Field>
                </div>
                <ErrorMessage name="commune" class="text-danger" />
              </div>
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nombre d'années d'expérience <span class="text-danger">*</span>
                  </label>
                  <Field name="experience" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le nombre" />
                  <ErrorMessage name="experience" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Nombre de postes disponibles <span class="text-danger">*</span>
                  </label>
                  <Field name="nombrePoste" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le nombre" />
                  <ErrorMessage name="nombrePoste" class="text-danger" />
                </div>
              </div>
              <div class="col-md-4 mb-3">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Indication
                  </label>
                  <Field name="indication" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le lieu" />
                  <ErrorMessage name="indication" class="text-danger" />
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Description <span class="text-danger">*</span>
                  </label>

                  <div class="mb-0">
                    <QuillEditor ref="descriptionEditor" theme="snow" placeholder="Écrivez la description de l'offre"
                      toolbar="full" name="description" />
                  </div>

                  <p class="text-danger" v-if="show === '1'">Ce champ est obligatoire</p>
                </div>
              </div>


              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de publication <span class="text-danger">*</span>
                  </label>
                  <Field name="datePublication" type="date" :min="currentDate"
                    class="form-control shadow-none fs-md-15 text-black" />
                </div>
                <ErrorMessage name="datePublication" class="text-danger" />
              </div>
              <div class="col-md-4">
                <div class="form-group mb-15 mb-sm-20 mb-md-25">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date d'expiration <span class="text-danger">*</span>
                  </label>
                  <Field name="dateExpiration" type="date" class="form-control shadow-none fs-md-15 text-black" />
                </div>
                <ErrorMessage name="dateExpiration" class="text-danger" />
              </div>

              <div class="col-md-12 mt-3">
                <div class="d-flex align-items-center ">
                  <button ref="submitButton" class="btn btn-success me-3" type="submit">
                    Ajouter une offre
                  </button>
                  <router-link to="/liste-offres" class=" btn btn-danger"><i
                      class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                    <span class="position-relative"></span>Annuler</router-link>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </template>

<script lang="ts">

import { defineComponent, ref, watch, reactive, onMounted } from 'vue';
import { Form, Field, ErrorMessage, useFieldArray } from 'vee-validate';
import { error, success } from '@/utils/utils';
import { useRouter } from "vue-router";
import ApiService from '@/services/ApiService';
import { Offre } from '@/models/Offre';
import * as Yup from 'yup';
import Multiselect from '@vueform/multiselect'

import axios from 'axios';

export default defineComponent({
  name: "AddOffre",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,

  },
  setup: () => {
    const currentDate = ref(new Date().toISOString().split('T')[0]);

    const offreSchema = Yup.object().shape({
      categorieOffre: Yup.string()
        .required("La catégorie est obligatoire"),
      activite: Yup.string()
        .required("L'activité est obligatoire"),
      titre: Yup.string()
        .required("Le titre est obligatoire"),
      description: Yup.string()
        .notRequired(),
      salaire: Yup.string()
        .required("Le salaire est obligatoire"),
      indication: Yup.string()
        .notRequired(),
      experience: Yup.string()
        .notRequired(),
      nombrePoste: Yup.string()
        .notRequired(),
      commune: Yup.string()
        .required("La commune est obligatoire"),
      datePublication: Yup.date()
        .required('La date de début est obligatoire')
        .typeError('Veuillez entrer une date valide'),
      dateExpiration: Yup.date()
        .required('La date de fin est obligatoire')
        .typeError('Veuillez entrer une date valide')
        .min(
          Yup.ref('datePublication'),
          'La date de fin doit être postérieure à la date de début!'
        ),

    });

    const offreForm = ref<Offre | null>(null);
    const router = useRouter();
    const defaultStatut = ref(1);
    //const showAdditionalFields = ref(true);
    const submitButton = ref<HTMLButtonElement | null>(null);
    const categorieOffresOptions = ref([]);
    const activiteOptions = ref([]);
    const communeOptions = ref([]);
    const descriptionEditor = ref();
    const empty = ref("");
    const show = ref("0");
    const showA = ref(false);

    const valuess = ref();


    const fetchCategorie = async () => {
      try {
        const response = await axios.get('/categorieOffres');
        const categorieOffresData = response.data.data.data;
        categorieOffresOptions.value = categorieOffresData.map((categorieOffres) => ({
          value: categorieOffres.id,
          label: `${categorieOffres.libelle}`,
        }));
      } catch (error) {
        //
      }
    };


    const fetchActivite = async () => {
      try {
        const response = await axios.get('/activites');
        const activitesData = response.data.data.data;
        activiteOptions.value = activitesData.map((activites) => ({
          value: activites.id,
          label: `${activites.libelle}`,
        }));
      } catch (error) {
        //
      }
    };


    const fetchCommune = async () => {
      try {
        const response = await axios.get('/communes');
        const communesData = response.data.data.data;
        communeOptions.value = communesData.map((communes) => ({
          value: communes.id,
          label: `${communes.libelle}`,
        }));
      } catch (error) {
        //
      }
    };


    onMounted(() => {
      fetchCategorie();
      fetchActivite();
      fetchCommune();
    })

    const addOffre = async (values, { resetForm }) => {
      // --- Vérification du contenu de l’éditeur Quill ---
      values["description"] = descriptionEditor.value.getHTML();
      if (values["description"] === empty.value) {
        showA.value = true;
        show.value = "1"; // Affiche le message d’erreur
        return;
      } else {
        showA.value = false;
        show.value = "0"; // Cache le message d’erreur
      }

      // --- Désactivation du bouton pendant l’envoi ---
      if (submitButton.value) {
        submitButton.value.disabled = true;
      }

      try {
        const { data } = await ApiService.post("/offres", values);

        if (data.code === 201) {
          success(data.message);
          resetForm();
          router.push({ name: "ListeOffrePage" });
        }
      } catch (err: any) {
        if (submitButton.value) {
          submitButton.value.disabled = false;
        }

        if (err.response?.data?.message) {
          error(err.response.data.message);
        } else {
          error("Une erreur est survenue lors de l’envoi de l’offre");
        }
      }
    };




    return {
      offreSchema,
      addOffre,
      offreForm,
      defaultStatut,
      submitButton,
      valuess,
      currentDate,
      categorieOffresOptions,
      activiteOptions, communeOptions,
       descriptionEditor,showA, empty ,
     show
       

    };
  },
});
</script>
<style scoped>
.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}
</style>
